module.exports = __webpack_public_path__ + "static/media/gc-bg.9756301d.png";